import { render } from "./Elements.vue?vue&type=template&id=7fd480f5&scoped=true"
import script from "./Elements.vue?vue&type=script&lang=js"
export * from "./Elements.vue?vue&type=script&lang=js"

import "./Elements.vue?vue&type=style&index=0&id=7fd480f5&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd480f5"]])

export default __exports__